// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26mOi","image":"Header_image__2luYN","name":"Header_name__ECEcZ","info":"Header_info__940Gr","infoRow":"Header_infoRow__2sWZY"};